import { useState } from "react"
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary"
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin"
import { ListPlugin } from "@lexical/react/LexicalListPlugin"

import { ContentEditable } from "../../editor/editor-ui/content-editable"
import { BlockFormatDropDown } from "../../editor/plugins/toolbar/block-format-toolbar-plugin"
import { ToolbarPlugin } from "../../editor/plugins/toolbar/toolbar-plugin"
import { FormattingToolbar } from "../../editor/plugins/toolbar/formatting-toolbar"
import { EnterKeyPlugin } from "../../editor/plugins/enter-key-plugin"

export function Plugins() {
  const [floatingAnchorElem, setFloatingAnchorElem] =
    useState<HTMLDivElement | null>(null)

  const onRef = (_floatingAnchorElem: HTMLDivElement) => {
    if (_floatingAnchorElem !== null) {
      setFloatingAnchorElem(_floatingAnchorElem)
    }
  }

  return (
    <div className="relative">
      {/* Block Format Toolbar */}
      {/* <ToolbarPlugin>
        {({ blockType }) => (
          <div className="border-b border-gray-200 p-2 bg-gray-50">
            <BlockFormatDropDown>
              <span className="text-sm">{blockType}</span>
            </BlockFormatDropDown>
          </div>
        )}
      </ToolbarPlugin> */}
      
      {/* Text Formatting Toolbar */}
      <FormattingToolbar />
      
      <div className="relative">
        <RichTextPlugin
          contentEditable={
            <div className="">
              <div className="" ref={onRef}>
                <ContentEditable placeholder={""} />
              </div>
            </div>
          }
          ErrorBoundary={LexicalErrorBoundary}
        />
        <ListPlugin />
        <EnterKeyPlugin />
        {/* editor plugins */}
      </div>
      {/* actions plugins */}
    </div>
  )
}
